var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg420(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2923)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8662 18.095H13.7162V16.595L16.7162 9.5H18.5162V16.595H19.2962V18.095H18.5162V20H16.8662V18.095ZM16.8662 16.595V12.5H16.8362L15.2162 16.595H16.8662ZM20.0821 18.86C20.0821 18.11 20.2021 17.47 20.4421 16.94C20.6821 16.4 21.1121 15.805 21.7321 15.155C22.3421 14.505 22.7621 13.95 22.9921 13.49C23.2321 13.03 23.3521 12.55 23.3521 12.05C23.3521 11.6 23.2771 11.29 23.1271 11.12C22.9871 10.94 22.7771 10.85 22.4971 10.85C21.9271 10.85 21.6421 11.195 21.6421 11.885V13.01H20.0821V11.99C20.0821 11.14 20.2921 10.49 20.7121 10.04C21.1321 9.58 21.7421 9.35 22.5421 9.35C23.3421 9.35 23.9521 9.58 24.3721 10.04C24.7921 10.49 25.0021 11.14 25.0021 11.99C25.0021 12.63 24.8471 13.255 24.5371 13.865C24.2371 14.475 23.7121 15.175 22.9621 15.965C22.4721 16.485 22.1421 16.91 21.9721 17.24C21.8021 17.56 21.7171 17.905 21.7171 18.275V18.5H24.8521V20H20.0821V18.86ZM28.5029 20.15C27.6929 20.15 27.0729 19.92 26.6429 19.46C26.2129 19 25.9979 18.35 25.9979 17.51V11.99C25.9979 11.15 26.2129 10.5 26.6429 10.04C27.0729 9.58 27.6929 9.35 28.5029 9.35C29.3129 9.35 29.9329 9.58 30.3629 10.04C30.7929 10.5 31.0079 11.15 31.0079 11.99V17.51C31.0079 18.35 30.7929 19 30.3629 19.46C29.9329 19.92 29.3129 20.15 28.5029 20.15ZM28.5029 18.65C29.0729 18.65 29.3579 18.305 29.3579 17.615V11.885C29.3579 11.195 29.0729 10.85 28.5029 10.85C27.9329 10.85 27.6479 11.195 27.6479 11.885V17.615C27.6479 18.305 27.9329 18.65 28.5029 18.65Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2923",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2923",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg420);
export default __webpack_public_path__ + "static/media/420.8496cde3cd9dd5edefb8c96456abd04a.svg";
export { ForwardRef as ReactComponent };